import { retryFetch } from './RetryHelper';
import { debug } from "src/logger";
import initialMetricsPublisher from "src/metrics";

interface ValidateIntakeRequest {
    intakeId: string;
    businessName: string;
    zipCode: string;
}

interface ValidateIntakeResponse {
    reportingId: string;
    status: string;
}

export const validateIntake = async (params: ValidateIntakeRequest): Promise<ValidateIntakeResponse> => {
    try {
        return await retryFetch(async () => {
            debug('Making ValidateIntake Request:', params);
            const response = await fetch('/getstarted/api/validateIntake', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(params)
            });
            if (!response.ok) {
                if (response.status === 429) {
                    const actionMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod('ValidateIntakeCall');
                    actionMetricsPublisher.publishCounterMonitor('MonsServiceRateLimitCount', 1);
                }
                throw new Error('Encountered exception when calling ValidateIntake')
            }
            const data = await response.json();
            debug('Received ValidateIntake Response:', data);

            return {
                reportingId: data.reportingId,
                status: data.status
            };
        });
    } catch (error) {
        console.error('Encountered exception calling ValidateIntake');
        return { reportingId: '', status: '' };
    }
};
